// import { useGlobalContext } from "../context/globalContext";
// import { useEffect } from "react";
// import { motion } from "framer-motion";
// import { Trash, Star } from "lucide-react";

// const ProductList: React.FC = () => {
//   const { products, getProducts, deleteProduct, toggleFeaturedProduct, createProduct } = useGlobalContext();

//   // Fetch products only once when the component mounts or when a product is added
//   useEffect(() => {
//     getProducts();
//   }, [getProducts, createProduct]);

//   // Remove duplicate products based on `_id` and `name`
//   const uniqueProducts = Array.from(
//     new Map(products.map(product => [`${product._id}-${product.name}`, product])).values()
//   );

//   return (
//     <motion.div
//       className="bg-dark shadow-lg rounded-lg overflow-hidden mx-auto"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8 }}
//     >
//       <table className="table table-bordered table-striped text-white">
//         <thead className="bg-secondary">
//           <tr>
//             <th scope="col">Product</th>
//             <th scope="col">Price</th>
//             <th scope="col">Category</th>
//             <th scope="col">Featured</th>
//             <th scope="col">Actions</th>
//           </tr>
//         </thead>
//         <tbody className="bg-dark">
//           {uniqueProducts.map((product, index) => (
//             <tr key={`${product._id}-${index}`} className="hover-table">
//               <td>
//                 <div className="d-flex align-items-center">
//                   <div className="flex-shrink-0 me-3">
//                     <img
//                       className="rounded-circle"
//                       src={product.image}
//                       alt={product.name}
//                       style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                     />
//                   </div>
//                   <div>
//                     <div className="text-sm font-weight-bold">{product.name}</div>
//                   </div>
//                 </div>
//               </td>
//               <td>
//                 <div className="text-sm text-muted">
//                   #{product.price.toFixed(2)}
//                 </div>
//               </td>
//               <td>
//                 <div className="text-sm text-muted">
//                   {product.category}
//                 </div>
//               </td>
//               <td>
//                 <button
//                   onClick={() => toggleFeaturedProduct(product._id.toString())}
//                   className={`btn btn-sm rounded-circle ${product.isFeatured ? "btn-warning" : "btn-secondary"}`}
//                 >
//                   <Star className="h-5 w-5" />
//                 </button>
//               </td>
//               <td>
//                 <button
//                   onClick={() => deleteProduct(product._id.toString())}
//                   className="btn btn-sm btn-danger"
//                 >
//                   <Trash className="h-5 w-5" />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </motion.div>
//   );
// };

// export default ProductList;







import { useGlobalContext } from "../context/globalContext";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trash, Star, Edit } from "lucide-react";
import { Modal, Button, Form } from "react-bootstrap";
import "./ProductList.css"; // ✅ Add this import

const ProductList: React.FC = () => {
  const { products, getProducts, deleteProduct, toggleFeaturedProduct, updateProduct } = useGlobalContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const productsPerPage = 20;

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const uniqueProducts = Array.from(
    new Map(products.map((product) => [`${product._id}-${product.name}`, product])).values()
  );

  const totalPages = Math.ceil(uniqueProducts.length / productsPerPage);
  const startIndex = (currentPage - 1) * productsPerPage;
  const currentProducts = uniqueProducts.slice(startIndex, startIndex + productsPerPage);

  const handleEdit = (product: any) => {
    setSelectedProduct({ ...product });
    setShowModal(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setSelectedProduct((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    if (!selectedProduct) return;
    await updateProduct(selectedProduct);
    setShowModal(false);
  };

  return (
    <>
      <motion.div
        className="bg-dark shadow-lg rounded-lg overflow-hidden mx-auto p-2 p-md-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ✅ Responsive table wrapper */}
        <div className="table-container">
          <table className="table table-bordered table-striped text-white">
            <thead className="bg-secondary">
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Category</th>
                <th>Featured</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="bg-dark">
              {currentProducts.map((product, index) => (
                <tr key={`${product._id}-${index}`}>
                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        className="rounded-circle me-2"
                        src={product.image}
                        alt={product.name}
                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                      />
                      <span className="fw-semibold">{product.name}</span>
                    </div>
                  </td>
                  <td>₦{product.price.toFixed(2)}</td>
                  <td>{product.category}</td>
                  <td>
                    <button
                      onClick={() => toggleFeaturedProduct(product._id.toString())}
                      className={`btn btn-sm rounded-circle ${
                        product.isFeatured ? "btn-warning" : "btn-secondary"
                      }`}
                    >
                      <Star className="h-5 w-5" />
                    </button>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <button onClick={() => handleEdit(product)} className="btn btn-sm btn-info">
                        <Edit className="h-5 w-5" />
                      </button>
                      <button
                        onClick={() => deleteProduct(product._id.toString())}
                        className="btn btn-sm btn-danger"
                      >
                        <Trash className="h-5 w-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-center my-3">
          <nav>
            <ul className="pagination">
              {[...Array(totalPages)].map((_, i) => (
                <li key={i} className={`page-item ${i + 1 === currentPage ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </motion.div>

      {/* Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control name="name" value={selectedProduct.name} onChange={handleChange} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={selectedProduct.description}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="number"
                  name="price"
                  value={selectedProduct.price}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  name="category"
                  value={selectedProduct.category}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Image (optional)</Form.Label>
                <Form.Control
                  name="image"
                  placeholder="Paste new image URL or Base64"
                  onChange={handleChange}
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductList;
